export const eligibleUbkList = ['9017', '9018'];
export const documentsList: {
  [key: string]: {
    name: string;
    id: string;
    description: string;
    label: string;
  };
} = {
  eob: {
    name: 'Explanation of Benefits',
    id: 'eob',
    description:
      'This document helps you understand what costs your insurance plan covered, and what you may still be responsible for.',
    label: 'See All Explanation of Benefits',
  },
  // commenting out for version upgrade to not to reflect on PROD

  // 'determination-notices': {
  //   name: 'Determination Notices',
  //   id: 'determination-notices',
  //   description:
  //     'These documents outline the approval, denial, or pending status of a healthcare service/medication authorization request.',
  //   label: 'See All Notices',
  // },
  // 'ma-welcome-guides': {
  //   name: 'MA Welcome Guides',
  //   id: 'ma-welcome-guides',
  //   description: 'Your Welcome Guides.',
  //   label: 'See all Welcome Guides',
  // },
};
